import { del, getJson, patchJson, postJson, putJson } from 'utils/http';

export type WorkHistoryJob = {
  id: string;
  synonymId: string | null | undefined;
  text: string;
  titleSuggestion: string | null | undefined;
  title?: {
    selectedId: string;
    selectedText: string;
    standardId: string;
    standardText: string;
    text?: string;
  };
  orgName: string | null | undefined;
  orgId: string | null | undefined;
  isCurrent: boolean;
  startDate: (string | null | undefined) | (number | null | undefined);
  endDate: (string | null | undefined) | (number | null | undefined);
  positionType: 'JOB' | 'INTERNSHIP' | 'VOLUNTEER';
  isFullTime: boolean;
  managerialStatus: boolean;
};
export type Location = SearchLocation & {
  full: string;
};
export type ApplicantProfile = {
  id: string;
  willingToRelocate: boolean | null | undefined;
  prefersRemote: boolean | null | undefined;
  openToRemote: boolean | null | undefined;
  location: Location | null | undefined;
  skills: Array<string> | null | undefined;
  workHistoryJobs: Array<WorkHistoryJob>;
  updatedByUser: string;
};
type ApplicantProfileResponse = {
  resumeId: string | null | undefined;
  isRecruitable: boolean | null | undefined;
  applicantProfile: ApplicantProfile | null | undefined;
};
const emptyProfile = {
  resumeId: null,
  isRecruitable: null,
  workHistoryJobs: [],
};

const mapProfileResponse = ({ applicantProfile }) => {
  const {
    resumeS3FileId: resumeId,
    isRecruitable,
    ...profile
  } = applicantProfile || emptyProfile;
  return {
    resumeId,
    isRecruitable,
    applicantProfile: profile,
  };
};

export const fetchApplicantProfile = (): Promise<ApplicantProfileResponse> =>
  getJson('/data/userdashboard/applicant-profile/profile').then(
    mapProfileResponse
  );
export const updateApplicantProfile = (
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  values: Record<string, any>
): Promise<ApplicantProfileResponse> =>
  patchJson('/data/userdashboard/applicant-profile/profile', values).then(
    mapProfileResponse
  );
export const addWorkHistoryJob = (
  job: WorkHistoryJob
): Promise<ApplicantProfileResponse> =>
  postJson('/data/userdashboard/applicant-profile/work-history/jobs', job).then(
    mapProfileResponse
  );
export const editWorkHistoryJob = (
  id: string,
  job: WorkHistoryJob
): Promise<ApplicantProfileResponse> =>
  putJson(
    `/data/userdashboard/applicant-profile/work-history/jobs/${id}`,
    job
  ).then(mapProfileResponse);
export const deleteWorkHistoryJob = (
  id: string
): Promise<ApplicantProfileResponse> =>
  del(`/data/userdashboard/applicant-profile/work-history/jobs/${id}`).then(
    mapProfileResponse
  );
export const fetchUserByEmail = (email: string) =>
  getJson(`/data/users/by-email?email=${encodeURIComponent(email)}`).then(
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'userExists' does not exist on type 'unkn... Remove this comment to see the full error message
    (result) => result && result.userExists
  );
